
import React from 'react';
import { ContactForm } from './form';
import { ContactInfo } from './form';

const ContactFormSection = () => {
  return (
    <section className="section py-12 md:py-16" id="contactformulier">
      <div className="container">
        <div className="grid md:grid-cols-2 gap-12">
          <ContactInfo />
          <ContactForm />
        </div>
      </div>
    </section>
  );
};

export default ContactFormSection;
